import { useTranslation } from "react-i18next";
import TopupMain from "../components/TopupMain/TopupMain";
import RechargeButton from "../components/TopupSummary/RechargeButton";
import { useRechargeSummary } from "../hooks/useRechargeSummary";

export default function TopupDetailsMob() {
  const { t } = useTranslation();
  const rechargeValues = useRechargeSummary();

  return (
    <div className="flex w-full flex-col gap-4 p-5 pb-24 -mt-35 z-20">
      <div className="rounded-md bg-background-default">
        <TopupMain />
      </div>
      <div className="fixed bottom-0 start-0 right-0 z-50">
        <div className="shadow-bottom-sheet rounded-t-xl bg-background-default p-4">
          <RechargeButton {...rechargeValues} triggerLabel={t("Topup.checkout")} />
        </div>
      </div>
    </div>
  );
}
